<script>
    import VcPaginacao from "@/components/Form/Paginacao";
    import VcDetalhesDocumentos from "./DetalhesDocumentos"

    export default {
        components: {
            VcPaginacao,
            VcDetalhesDocumentos
        },
        data() {
            return {
                pedidos: {},
                nomeCliente: '',
                numero: '',
                registros: {
                    inicial: null,
                    final: null
                },
                pagination: {},
                pedidoSelecionado: null,
                porPagina: {label: "100", value: "100"},
            };
        },

        watch: {
            porPagina() {
                this.navigate(1);
            },
            nomeCliente() {
                this.navigate(1);
            }
        },

        methods: {
            navigate(pagina) {
                this.$http.post("api/analises/listagemDocumentos?page=" + pagina, {
                    porPg: this.porPagina.value,
                    nomeCliente: this.nomeCliente,
                    registros: this.registros,
                    numero: this.numero
                }).then(response => {
                    this.pedidos = response.data.data;
                    this.pagination = response.data;
                });
            },

            download(pedido, enviarEmail = false) {
                window.swal({
                    title: enviarEmail ? 'Enviando e-mail...' : 'Gerando relatório...',
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post("api/relatorio/gerar/relatorioRelacaoAnalises", {dataVencimentoBoleto: pedido.data_vencimento_boleto, dataEmissao: pedido.data_criacao_formatada, enviarEmail, pedidoId: pedido.id, nota: pedido.numero_nota, boleto: pedido.nosso_numero_boleto}).then(response => {
                            if (enviarEmail) {
                                if (response.data.erro) {
                                    return window.swal("Atenção", "Houve um problema ao enviar e-mail.<br><br>" + response.data.mensagem, "warning");
                                } else {
                                    return window.swal("Sucesso", "E-mail enviado com sucesso.", "success");
                                }
                            } else {
                                if (response.data.pdf == null) {
                                    return window.swal("Atenção", "Houve um problema ao realizar download.<br><br>" + response.data.mensagem, "warning");
                                }
                                let a = document.createElement("a");
                                a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                a.download = `Relação ${pedido.nome_razao_social} (${pedido.cpf_cnpj}).pdf`;
                                a.click();
                                window.swal("Sucesso", "Relação gerada com sucesso.", "success");
                            }
                        });
                    }
                });
            }
        },

        mounted() {
            this.navigate(1);
            this.$store.dispatch("setTitle", "Documentos emitidos");
        }
    };

</script>

<template>
    <div class="margin-top-10">
        <vc-detalhes-documentos :pedido-prop="pedidoSelecionado" @close="() => pedidoSelecionado = null"/>
    
        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-2">
                        <label>Registros por página</label>
                        <v-select
                                v-model="porPagina"
                                :options="[
                                {label: '10', value: '10'},
                                {label: '25', value: '25'},
                                {label: '50', value: '50'},
                                {label: '100', value: '100'},
                            ]"
                        ></v-select>
                    </div>
                    
                    <div class="col-xs-12 col-sm-2">
                        <div class="form-group">
                            <label>Número NFS-e ou boleto</label>
                            <input v-model="numero" @blur="navigate(1)" type="text" class="form-control" placeholder="Pesquisar">
                        </div>
                    </div>
        
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>Registros</label>
                            <div class="row">
                                <div class="col-xs-6 col-sm-6">
                                    <input type="text" v-model="registros.inicial" @blur="navigate(1)" class="form-control" placeholder="Registro inicial"/>
                                </div>
                                <div class="col-xs-6 col-sm-6">
                                    <input type="text" v-model="registros.final" @blur="navigate(1)" class="form-control" placeholder="Registro final"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4 pull-right">
                        <div class="form-group">
                            <label>Remetente / Proprietário</label>
                            <input v-model="nomeCliente" type="text" class="form-control" placeholder="Pesquisar">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <table class="table dataTable">
                            <thead>
                            <tr role="row">
                                <th width="9%">Data</th>
                                <th width="30%">Remetente / Proprietário</th>
                                <th width="14%">Pagamento</th>
                                <th width="14%">NFS-e</th>
                                <th width="19%">Boleto</th>
                                <th width="7%" class="text-center">Valor (R$)</th>
                                <th width="7%" class="text-center">Ações</th>
                            </tr>
                            </thead>
                            <tbody :key="indexPedido" v-for="(pedido, indexPedido) in pedidos">
                            <tr role="row" class="even">    
                                <td>{{ pedido.data_criacao_formatada }}</td>
                                <td>{{ `${pedido.nome_razao_social} (${pedido.cpf_cnpj})` }}</td>
                                <td>{{ pedido.nosso_numero_boleto === null ? 'Dinheiro / Transferência' : 'Boleto bancário' }}</td>
                                <td>{{ pedido.numero_nota === null ? '---' : pedido.numero_nota }}</td>
                                <td>{{ pedido.nosso_numero_boleto === null ? '---' : (pedido.nosso_numero_boleto + ` (Venc. ${pedido.data_vencimento_boleto})`) }}</td>
                                <td class="text-center">{{ pedido.vlr_liquido | formatMoney }}</td>
                                <td class="text-center lista-analises">
                                    <button class="btn btn-xs btn-info"
                                            @click="download(pedido)"
                                            title="Imprimir"><i class="fa fa-print"></i>
                                    </button>

                                    <button class="btn btn-xs btn-info"
                                            @click="download(pedido, true)"
                                            title="Enviar por e-mail"><i class="fa fa-envelope"></i>
                                    </button>

                                     <button class="btn btn-xs btn-info"
                                            @click="() => pedidoSelecionado = pedidos[indexPedido]"
                                            title="Detalhes"><i
                                            :class="{'fa fa-plus': !pedido.detalhe, 'fa fa-minus': pedido.detalhe}"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <vc-paginacao :source="pagination" @navigate="navigate"></vc-paginacao>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    table th {
        font-size: 15px !important;
    }

    table td {
        font-size: 13px !important;
    }

    table.dataTable thead th,
    table.dataTable thead td {
        padding: 10px 18px;
        border-bottom: 1px solid #111;
    }

    @media screen and (max-width: 584px) {
        table th:nth-child(2) {
            display: none;
        }

        table td:nth-child(2) {
            display: none;
        }
    }

    @media screen and (max-width: 445px) {
        table th:nth-child(3) {
            display: none;
        }

        table td:nth-child(3) {
            display: none;
        }
    }

    @media screen and (max-width: 600px) {
        table th:nth-child(6) {
            display: none;
        }

        table td:nth-child(6) {
            display: none;
        }
    }

    @media screen and (max-width: 600px) {
        table th:nth-child(4) {
            display: none;
        }

        table td:nth-child(4) {
            display: none;
        }
    }

    @media screen and (max-width: 400px) {
        table th:nth-child(7) {
            display: none;
        }

        table td:nth-child(7) {
            display: none;
        }
    }

    .lista-analises button {
        margin-left: 5px;
    }

    .nav-tabs > li.active > a {
        font-weight: bold;
    }

    .table-striped > tbody > tr:nth-of-type(odd) {
        background-color: #ebeef2;
    }

    .nao-paga {
        background-color: #FFB2B2 !important;
    }

    .nao-paga-boleto {
        background-color: #FFFFB2 !important;
    }
</style>
